"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogViewLayout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const log_context_1 = require("../context/log-context");
const react_router_dom_1 = require("react-router-dom");
const log_1 = require("../model/log");
exports.LogViewLayout = (0, react_1.memo)(({ children, eventName }) => {
    const [searchParams] = (0, react_router_dom_1.useSearchParams)();
    const from = searchParams.get("from");
    const { logEvent } = (0, log_context_1.useLog)();
    (0, react_1.useEffect)(() => {
        logEvent(log_1.LogEventType.View, eventName, { from });
    }, [logEvent, eventName, from]);
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
});
